import styled from "@emotion/styled";
import { Dropdown } from "primereact/dropdown";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 100%;
  padding-top: 10px;

  .buttons {
    display: flex;
    flex-direction: row;
    gap: 15px;
  }

  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #14223b;
    border-radius: 6px;
    border: 1px solid #ced4da;
    padding: 10px 12px;
    width: 50%;
    font-weight: 600;
    gap: 10px;
  }

  .no-hover-button:hover {
    background: inherit;
    color: inherit;
    border-color: inherit;
    box-shadow: none;
    border: 1px solid #ced4da;
  }

  .stages {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .title {
    display: flex;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
  }

  .containerStages {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    gap: 10px;
  }

  hr {
    width: 100%;
    border: 1px solid #e5e5e5;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 100%;
  overflow-y: auto;

  .fields {
    display: flex;
    flex-direction: column;
  }

  .field {
    display: flex;
    flex-direction: column;
    width: 97%;
    color: #6c757d;
  }

  .hrDiv {
    display: flex;
    width: 97%;
  }

  .space {
    background-color: transparent;
    height: 25px;
  }

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const StageDropdown = styled(Dropdown)<{
  bgColor?: string;
  borderColor?: string;
  textColor?: string;
}>`
  display: flex;
  align-items: center;
  height: 38px;
  background-color: ${({ bgColor }) => bgColor ?? "#fff"};
  border: 1px solid ${({ borderColor }) => borderColor ?? "#ced4da"};

  .p-inputtext {
    color: ${({ textColor }) => textColor ?? "#000"};
    font-size: 14px !important;
    text-align: center;
  }

  .p-dropdown-trigger,
  .p-dropdown-trigger-icon {
    color: ${({ textColor }) => textColor ?? "#000"};
  }
`;

export const ContactAutocompleteWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ContactSuggestions = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-shadow: 0 8px 18px rgba(20, 34, 59, 0.12);
`;

export const ContactSuggestionItem = styled.button`
  && {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2px;
    padding: 8px 10px;
    border: none;
    border-radius: 0;
    background: #fff;
    color: #6e6b7b;
    cursor: pointer;
    text-align: left;
    font-weight: 400;
  }

  &:hover {
    background: #f5f7fb;
  }

  .suggestion-name {
    color: #14223b;
    font-size: 13px;
    font-weight: 600;
  }

  .suggestion-detail {
    color: #6e6b7b;
    font-size: 12px;
    word-break: break-word;
  }
`;

export const LabelMultiSelectWrapper = styled.div`
  width: 100%;

  .p-multiselect {
    min-height: 38px;
    height: auto;
    width: 100%;
  }

  .p-multiselect-label-container {
    display: flex;
    align-items: center;
    min-height: 36px;
    height: auto;
    padding: 0 6px;
    font-size: 12px;
  }

  .p-inputwrapper-filled .p-multiselect-label-container {
    padding: 8px 12px;
  }

  .p-multiselect-label {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 4px 6px;
    white-space: normal;
    height: auto;
    color: #6e6b7b !important;
  }

  .p-multiselect-token {
    background: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .p-multiselect-token-label {
    padding: 0 !important;
  }

  .p-placeholder {
    color: #6e6b7b !important;
  }

  .p-inputwrapper-filled.p-multiselect.p-multiselect-chip .p-multiselect-label {
    padding: 0;
  }
`;

export const LabelChip = styled.span<{ bgColor?: string; isLight?: boolean }>`
  background-color: ${({ bgColor }) => bgColor ?? "transparent"};
  color: ${({ isLight }) => (isLight ? "#000" : "#fff")};
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
`;

export const NameIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 10px;

  .divisor {
    display: flex;
    flex-direction: column;
  }

  .contactId {
    color: #046af3;
  }

  .contactName {
    font-weight: 600;
  }

  .contactEmail {
    color: #666666;
  }
`;

export const OptionsButtons = styled.div`
  display: flex;
  flex-direction: row;
  //   gap: 10px;

  div {
    display: flex;
    justify-content: center;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    font-size: 12px;
    font-weight: 700;
    gap: 5px;
    align-items: center;
    cursor: pointer;
  }

  img {
    width: 16px;
  }
`;
